import axios from 'axios';
import { applyJwtInterceptor } from '@webapp-next/lib/request/utils/jwt';

const http = axios.create();

http.interceptors.request.use(function(config) {
  const baseURL = `https://${window.__APP__.API_REGION_HOSTNAME}/payroll/v1`;

  config.url = `${baseURL}${config.url}`;
  return config;
});

const jwtConfig = {
  aud: 'SVC_PAYROLL_V1',
  claims: {
    deputy_user_id: '',
    deputy_business_id: '',
    deputy_employee_profile_id: '',
    deputy_business_user_id: '',
    deputy_business_location_id: '',
  },
};

applyJwtInterceptor(http, jwtConfig);

export const get = http.get;
export const post = http.post;
export const put = http.put;
export default http;
